import {getSiteUrl} from "@/helpers/functions";

export interface ImageObjectInput {
    src: string;
    width?: number;
    height?: number;
    caption?: string;
    creditText?: string;
    license?: string;
    creator?: string;
}

export type ImageInput = string | ImageObjectInput;

export type ImageObjectNode = Record<string, unknown>;

const toAbsolute = (src: string): string => {
    if (/^https?:\/\//i.test(src)) return src;
    const path = src.startsWith("/") ? src : `/${src}`;
    return `${getSiteUrl()}${path}`;
};

export const buildImageObject = (input: ImageObjectInput): ImageObjectNode => {
    const node: ImageObjectNode = {
        "@type": "ImageObject",
        "url": toAbsolute(input.src),
        "contentUrl": toAbsolute(input.src),
    };
    if (typeof input.width === "number") node.width = input.width;
    if (typeof input.height === "number") node.height = input.height;
    if (input.caption) node.caption = input.caption;
    if (input.creditText) node.creditText = input.creditText;
    if (input.license) node.license = /^https?:\/\//i.test(input.license) ? input.license : toAbsolute(input.license);
    if (input.creator) node.creator = {"@type": "Person", "name": input.creator};
    return node;
};

export const coerceImageObject = (entry: ImageInput): ImageObjectNode =>
    typeof entry === "string" ? buildImageObject({src: entry}) : buildImageObject(entry);

export const coerceImageObjects = (entries: ImageInput[] | undefined): ImageObjectNode[] =>
    (entries ?? []).map(coerceImageObject);
